import { Plus } from "lucide-react";

/**
 * Floating Action Button for the mobile leads view.
 * Primary action: Add Lead. Desktop hides this entirely (md:hidden in parent).
 * Bulk Import & Export CSV now live in Settings → Data.
 */
export default function MobileFAB({ onAddLead }) {
  return (
    <div
      className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-2.5"
      data-testid="mobile-fab"
    >
      <button
        type="button"
        onClick={() => onAddLead?.()}
        aria-label="Add lead"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#0A2540] text-white shadow-xl ring-2 ring-white active:scale-95"
        data-testid="mobile-fab-add-lead"
      >
        <Plus className="h-6 w-6" />
      </button>
    </div>
  );
}
